import React, { useState } from "react";

import { useRouter } from "next/router";

import StaticIntlTranslator from "shared/components/atoms/StaticIntlTranslator";
import { getMode } from "shared/infra/services/api";

import { Button, PrivateReasonModal } from "./styles";

const ItemsToWarnThatIsPrivate = ({
  returnRoute,
  isContentScreen,
}: ItemsToWarnThatIsPrivateProps) => {
  const router = useRouter();
  const isNotProduction = getMode(true);

  const [showPrivateReasonModal, setShowPrivateReasonModal] = useState(false);

  return (
    <>
      {!isContentScreen ? (
        <div className="text-plus-btn-container">
          <h4>
            <StaticIntlTranslator id="common:registrationForThisContentIsClosed" />
          </h4>

          {isNotProduction && (
            <Button
              type="link"
              id="learn-more-btn"
              onClick={() => setShowPrivateReasonModal(true)}
            >
              <StaticIntlTranslator id="common:learnMore" />
            </Button>
          )}
        </div>
      ) : (
        <div className="text-plus-btn-container">
          <h3>
            <StaticIntlTranslator id="common:oohhh" />
          </h3>

          <p className="with-shadow">
            <StaticIntlTranslator id="common:youMustHaveAnActiveEnrollmentToWatchThisContent" />
          </p>

          <div className="return-btn-container">
            <Button
              type="primary"
              onClick={() => router.push(`${returnRoute}`)}
            >
              <StaticIntlTranslator id="common:backTo" />
            </Button>
          </div>
        </div>
      )}

      <PrivateReasonModal
        centered
        footer={null}
        visible={showPrivateReasonModal}
        onCancel={() => setShowPrivateReasonModal(false)}
      >
        <p>Texto descrevendo o motivo, se houver</p>
      </PrivateReasonModal>
    </>
  );
};

interface ItemsToWarnThatIsPrivateProps {
  returnRoute: string;
  isContentScreen: boolean;
}

export default ItemsToWarnThatIsPrivate;
